var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgExclusion2 = function SvgExclusion2(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.984,
    height: 25.908,
    viewBox: "0 0 18.984 25.908",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_2",
    "data-name": "Exclusion 2",
    d: "M-3640,21007.291a13.279,13.279,0,0,1-8.606-3.17,2.543,2.543,0,0,1-.886-1.93,5.95,5.95,0,0,1,1.765-4.25,6.015,6.015,0,0,1,4.268-1.752h6.929a6,6,0,0,1,4.261,1.752,5.955,5.955,0,0,1,1.761,4.25,2.543,2.543,0,0,1-.891,1.93A13.252,13.252,0,0,1-3640,21007.291Zm.005-14a5.961,5.961,0,0,1-5.954-5.953,5.961,5.961,0,0,1,5.954-5.953,5.961,5.961,0,0,1,5.953,5.953A5.961,5.961,0,0,1-3640,20993.289Z",
    transform: "translate(3649.495 -20981.383)",
    fill: "#191919"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExclusion2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Exclusion_2.2b2c086880990ecae49dcc9df47937e3.svg";